import { render, staticRenderFns } from "./GameProjectHeader.vue?vue&type=template&id=2ca80db2"
import script from "./GameProjectHeader.vue?vue&type=script&lang=js"
export * from "./GameProjectHeader.vue?vue&type=script&lang=js"
import style0 from "./GameProjectHeader.vue?vue&type=style&index=0&id=2ca80db2&prod&lang=scss&module=true"
import style1 from "./GameProjectHeader.vue?vue&type=style&index=1&id=2ca80db2&prod&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports